import queryString from 'query-string';
/**
 * Create an image URL for ImageSharp
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image || !image.src) {
        return '';
    }
    /**
     * Remove any query param string to ensure paramsString is applied correctly and
     * there are no double definitions (setting a param twice prevents any tranformations)
     */
    const imageSource = image.src.split('?')[0];
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        // Define default quality as 95 to ensure some reduction in size for all but the smallest images
        quality: imageParams.width && imageParams.width > 400 ? 95 : undefined,
        ...imageParams,
    };
    const paramsString = queryString.stringify(params);
    return `${imageSource}${paramsString ? `?${queryString.stringify(params)}` : ''}`;
}
export function getSrcs(image, upper, lower, steps, ratio, params) {
    const sizes = getRange(upper, lower, steps);
    return sizes.map((size) => `${imageUrl(image, {
        width: size,
        height: ratio ? size * ratio : undefined,
        ...params,
    })} ${size}w`);
}
function getRange(upper, lower, steps) {
    const difference = upper - lower;
    const increment = difference / (steps - 1);
    return [
        lower,
        ...Array(steps - 2)
            .fill('')
            .map((_, index) => Math.ceil(lower + increment * (index + 1))),
        upper,
    ];
}
